/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2021-2023 OKTET Labs Ltd. */
import { ResetPasswordFormContainer } from '@/bublik/features/auth';

export const ResetPasswordPage = () => {
	return <ResetPasswordFormContainer />;
};
